import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import APIKit from '../../config/APIKit';

export const fetchProfile = createAsyncThunk(
  'profile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await APIKit.get(`store/details`);
      if(response.status){
         const isArabicEnabled = response.data.lang_ar === true || response.data.lang_ar === "true";
         const pathParts = window.location.pathname.split("/").filter(Boolean);
         localStorage.setItem("store-key" ,pathParts?.[0])
         localStorage.setItem("enableArabic", isArabicEnabled)
         if (!isArabicEnabled) {
           localStorage.removeItem("language");
           localStorage.removeItem("i18nextLng");
         }
        return {
          ...response.data,
          key : pathParts?.[0]
        };
      }else{
        localStorage.clear();
        return rejectWithValue('Profile get failed');
      }
    } catch (error) {
      if (error && typeof error === 'object' && error.response) {
        return rejectWithValue(error.response?.data || 'Profile get failed');
      }
      return rejectWithValue('Profile get failed');
    }
  }
);
const localkey = localStorage.getItem("store-key")
const initialLanguage = localStorage.getItem("enableArabic") === "true"
  ? (localStorage.getItem("language") || "en")
  : "en";

const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profile: null,
    status: 'idle',
    error: null,
    storeKey : localkey||"",
    language: initialLanguage,
    enableArabic: localStorage.getItem("enableArabic") === "true"
  },
  reducers: {
    setLanguage: (state, action) => {
      if (!state.enableArabic) {
        state.language = "en";
        localStorage.removeItem("language");
        localStorage.removeItem("i18nextLng");
        return;
      }
      state.language = action.payload;
      localStorage.setItem("language", action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.storeKey =""
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profile = action.payload.data || action.payload;
        state.error = null;
        state.storeKey = action.payload.key;
        state.enableArabic = action.payload.lang_ar === true || action.payload.lang_ar === "true";
        if (!state.enableArabic) {
          state.language = "en";
        }
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = typeof action.payload === 'string' ? action.payload : 'Banner get failed';
        state.storeKey =""
      });
  },
});

export const { setLanguage } = profileSlice.actions;

export default profileSlice.reducer;
